import {render} from 'react-dom';
import {Provider} from 'react-redux';
import * as serviceWorker from './serviceWorkerRegistration';
import redux from 'config/store';
import {PersistGate} from 'redux-persist/integration/react';
import Root from './Root';
import '@fontsource/bodoni-moda/variable-full.css';
import 'ui/sass';
// import reportWebVitals from './reportWebVitals';

render(
  <Provider store={redux.store}>
    <PersistGate loading={null} persistor={redux.persistor}>
      <Root />
    </PersistGate>
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
